import React from "react";
import "../App.css";
import { Link } from 'react-router-dom'
import "./leaderboard.css"
import HeaderNav from "../misc/headerNav"
import profile1 from "../assets/StoryImage.jpg";
import like from "../assets/thumbsup2.png";
import gold from "../assets/goldCrown.png";
import silver from "../assets/silverCrown.png";
import purple from "../assets/purpCrown.png";

export default class LeaderBoard extends React.Component {
 // Michael worked on this file mostly... any questions please ask me :)
  constructor(props) {
    super(props);
    this.state = {
      userElement: [],
      posts: [],
      sortedlist: [],
      position: "",
      names: [],
    };
  }

  componentDidMount() {
    this.loadUsers();
  }

  //This pulls all users
  loadUsers() {

    // This is the fetch for the users
    fetch(process.env.REACT_APP_API_PATH + "/users", {
      method: "get",
      headers: {
        'Content-Type': 'application/json',
        'Authorization': 'Bearer ' + sessionStorage.getItem("token")
      }
    })
      .then(res => res.json())
      .then(
        result => {
          console.log("This here==========================>", JSON.stringify(result[0],null,4));
          if (result) {

            result[0].sort(function(a, b){
              return b.attributes.totalLikes - a.attributes.totalLikes;
          });

          console.log("This here==========================>", JSON.stringify(result[0],null,4));
            this.setState({
              userElement: result[0]
            });
          }
        },
        error => {
          console.log("An error has occured in fetch users!!!!")
        }
      );


    console.log("This here==========================>", JSON.stringify(this.state.userElement,null,4));

  }

  // Simple tool for the leader board and numbering
  locatePosition(number) {
    let compare = "", ret = "";
    compare = String(number);

    if (compare[compare.length - 1] === '1') {
      if (compare.length > 1) {
        if (compare[compare.length - 2] === '1') {
          ret = "th";
        } else {
          ret = "st";
        }
      } else {
        ret = "st";
      }
    } else if (compare[compare.length - 1] === '2') {

      if (compare.length == 2) {
        if (compare[compare.length - 2] === '1') {
          ret = "th";
        } else {
          ret = "nd";
        }
      } else {
        ret = "nd";
      }
    } else if (compare[compare.length - 1] === '3') {

      if (compare.length == 2) {
        if (compare[compare.length - 2] === '1') {
          ret = "th";
        } else {
          ret = "rd";
        }
      } else {
        ret = "rd";
      }
    } else {
      ret = "th";
    }
    return ret;
  }
  // Michaels side project to get the whole div clickable (not needed for sprint #3)
  // clickProfile(userId) {
  //   <Route path="/user/ userid" />
  // }

  // MAIN CONTENT
  render() {
    return (
      <div className="BackGround">
        <HeaderNav />

        <div className="boxLocation">
          <div className="leaderboard">Leaderboard</div>

          {/*This is a user element in the system that also loops*/}
          {this.state.userElement.map((user, index) => {
            return (

              <div className="userleader">
                <p className="number">{index + 1}{this.locatePosition(index + 1)}</p>

                <div className="storypic">
                  <Link to={"/user/"+user.id}>
                  <img src={user.attributes.pfp}
                    height='75'
                    width='75'
                    alt={user.attributes.name + " Profile Picture"}
                    className='storypic'
                  />
                  </Link>
                </div>
                <p className="userName">{user.attributes.username}</p>

                <img src={like} height='25' width='25' alt="Like Button" className='like' />
                <p className="num">{user.attributes.totalLikes}</p>

                {index === 0 ? <img src={gold} height='55' width='55' className="crown" alt="Gold Crown" /> : ""}

                {index == 1 ? <img src={silver} height='55' width='55' className="crown" alt="Silver Crown" /> : ""}

                {index === 2 ? <img src={purple} height='55' width='55' className="crown" alt="Purple Crown" /> : ""}
              </div>
            )
          })}
        </div>
      </div>
    );
  }
}